export const handleFlightCurrency = (airline) => {
  const brlAirlines = ["TAM", "TAP"]
  const eurAirlines = ["EZY", "RUK", "IBE"]

  if (eurAirlines.includes(airline)) {
    return ("€ ")
  } else {
    return ("R$ ")
  }
}

